/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === Math.floor(n) && (n >= 0 && n <= 1))
    return 1;
return 5;
}

export default ["ti",[["ቅ.ቀ.","ድ.ቀ."],u,u],u,[["ሰ","ሰ","ሰ","ረ","ሓ","ዓ","ቀ"],["ሰን","ሰኑ","ሰሉ","ረቡ","ሓሙ","ዓር","ቀዳ"],["ሰንበት","ሰኑይ","ሰሉስ","ረቡዕ","ሓሙስ","ዓርቢ","ቀዳም"],["ሰን","ሰኑ","ሰሉ","ረቡ","ሓሙ","ዓር","ቀዳ"]],u,[["ጥ","ለ","መ","ሚ","ግ","ሰ","ሓ","ነ","መ","ጥ","ሕ","ታ"],["ጥሪ","ለካ","መጋ","ሚያ","ግን","ሰነ","ሓም","ነሓ","መስ","ጥቅ","ሕዳ","ታሕ"],["ጥሪ","ለካቲት","መጋቢት","ሚያዝያ","ግንቦት","ሰነ","ሓምለ","ነሓሰ","መስከረም","ጥቅምቲ","ሕዳር","ታሕሳስ"]],u,[["ዓ/ዓ","ዓ/ም"],u,["ቅድመ ክርስቶስ","ዓመተ ምሕረት"]],0,[6,0],["dd/MM/yy","d MMM y","d MMMM y","EEEE፣ d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,"{1} ሰዓት {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"ETB","Br","ብር",{"CNY":[u,"¥"],"ETB":["Br"],"JPY":[u,"¥"],"USD":["US$","$"]},"ltr", plural];
